module.exports = __webpack_public_path__ + "static/Lato-Regular-bd03a2cc277bbbc338d464e679fe9942.woff2";